//export default class Headline {
//   constructor() {
//     this.$sections = document.querySelectorAll('section.headline');
//   }
//}
//
//new Headline();
import simpleParallax from "simple-parallax-js";

document.addEventListener("DOMContentLoaded", () => {
  var badge = document.querySelectorAll(".badge-parallax");
  new simpleParallax(badge, {
    orientation: "up",
    overflow: true,
    delay: 0.6,
  });
});
